<div>
    <input type="file" class="hidden-file-input" accept="image/png, image/jpeg" onclick="this.value = null"
      (change)="onFileSelected($event)" #fileUpload required>
    <h1>Add Events</h1>
    <br>
    <form [formGroup]="eventsForm">
      <label class="fixed-size" for="name">Name: </label>
      <input id="name" type="text" formControlName="name">
      <br>
      <div *ngIf="selectedFile != undefined; else noFile">
        <label class="fixed-size" for="event-image">Event Image: </label>
        <label>{{fileName}}</label><button class="remove-button" (click)="removeFile()">x</button>
      </div>
      <ng-template #noFile>
        <label class="fixed-size" for="events-image">Events Image: </label>
        <button class="add-button" (click)="fileUpload.click()">Add Image</button>
      </ng-template>
      <br>
      <label for="description">Description: </label><br>
      <textarea class="text-area-90" style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="10" cols="40"
        formControlName="description"></textarea>
      <br>
    </form>
    <form [formGroup]="eventsForm" (ngSubmit)="onSubmit()"></form>
    <button class="cancel-button" type="cancel" (click)="this.cancelClicked()">Cancel</button>
    <button class="primary-button" type="submit" [disabled]="!eventsForm.valid" (click)="this.onSubmit()">Submit</button>
  </div>